export default {
	methods: {
		setEnvLabels() {
			if (window.environment != "Production")
  				document.title = "tradetraks - "+window.environment

  			this.$store.environment = window.environment
		},
		initOneSignal() {
			if (window.OneSignalAppId && !this.$store.oneSignalInitialized) {
			  var OneSignal = window.OneSignal || [];
			  OneSignal.push(function() {
			    OneSignal.init({
			      appId: window.OneSignalAppId
			    });
			  });
			  this.$store.oneSignalInitialized = true;
			}
		},
		registerOneSignalId() {
			let vm = this

			if (typeof OneSignal != 'undefined') {
				OneSignal.push(() => {
					OneSignal.setExternalUserId(vm.$store.userDetails.slug)

					if (vm.$store.userDetails.has_push_notification_devices == 0) 
						vm.postData("User/save",{id:vm.$store.userDetails.id,has_push_notification_devices:1})
					
				})
			}

			/*let promiseResolved = false
			let giveUpCount = 5
			let unresolvedTimer

			if (!count)
				count = 1

			count++

			if (count < giveUpCount) {
				unresolvedTimer = setTimeout(() => {
					//try again if promise hasn't resolved in allotted time
					//console.log("unresolved promise checker...")
					if (!promiseResolved && count < giveUpCount) {
						//console.log("unresolved promise! trying again...")
						vm.registerOneSignalId(count)
					}
					else if (count >= giveUpCount) 
						console.warn("Unable to obtain OneSignal UserId")
					//else
					//	console.log("seems to have been resolved...")
				},5000)
			}

			if (!this.$store.oneSignalRegistered && typeof OneSignal != 'undefined') {

				console.log("registering onesignal...")

				OneSignal.getUserId().then(deviceId => {

					promiseResolved = true
					console.log("OneSignal deviceId: "+deviceId)

					if (deviceId) {

						if (!vm.deviceIdRegistered(deviceId)) {
							//not found, register it
							let payload = {
								device_id: deviceId
							}

							vm.postData("User/register-notifications",payload).then(response => {
								if (response.success) {

									vm.$store.oneSignalRegistered = true

									let deviceIds = []
									try {
										deviceIds = JSON.parse(vm.$store.userDetails.one_signal_user_id)
									}
									catch (e) {}

									deviceIds.push(deviceId)

									vm.$store.userDetails.one_signal_user_id = JSON.stringify(deviceIds)
									vm.$store.oneSignalDeviceId = deviceId
									localStorage.oneSignalDeviceId = deviceId

									clearTimeout(unresolvedTimer)

									console.log("OneSignal registered!")
								}
							})
						}
						else
							vm.$store.oneSignalRegistered = true
					}
					else {
						console.log("no device id")
						OneSignal.push(function() {
						  OneSignal.showHttpPrompt();
						});
					}
				}).catch(value => {
					console.log(value, " rejected")
				})
			}
			else {
				if (count < giveUpCount) {
					//console.log('OneSignal undefined, try again in 3 seconds')
					setTimeout(() => {
						//console.log("trying again")
						vm.registerOneSignalId(count)
					},5000)
				}
			}*/
		},
		showNotificationPrompt() {
			if (typeof OneSignal == 'object') {
				OneSignal.push(function() {
				  OneSignal.showNativePrompt();
				});
			}
		},
		setupPushNotifications(manual) {
			let vm = this

			if (this.loggedIn) {
				//setTimeout(() => {

					if (!OneSignal.isPushNotificationsEnabled())
						vm.initOneSignal()

					OneSignal.isPushNotificationsEnabled().then(response => {

						if (response)
							vm.registerOneSignalId()
						else {
							OneSignal.registerForPushNotifications().then(response => {
								vm.registerOneSignalId()
							})
						}
					})

				//},10000)
			}
		},
		checkApiKey() {
			if (!("apiKey" in localStorage))
				this.loggedIn = false
			else
				this.loggedIn = true
		},
		checkAppVersion() {
			let vm = this

			/*
			let cachedAppBundle = ""
			let cachedScripts = document.getElementsByTagName("script")

			for (let e of cachedScripts) {
				if (e.src.indexOf("/js/app.") >= 0)
					cachedAppBundle = e.src
			}
	
			fetch("/index.html").then(response => {

				if (response.ok) {
					response.text().then(body => {	
						
						let htmlBody = new DOMParser().parseFromString(body,"text/html")

						let scripts = htmlBody.getElementsByTagName("script")

						let currentAppBundle = ""

						for (let e of scripts) {

							if (e.src.indexOf("/js/app.") >= 0)
								currentAppBundle = e.src
							
						}

						if (currentAppBundle != cachedAppBundle && currentAppBundle != "") {

							let refreshAnchor="<a style='margin-left:10px;padding:0;margin:0;font-family:inherit;text-decoration:underline;cursor:pointer' onClick='if (confirm(\"Your browser will now refresh\")) window.location.reload(true)'>"

							vm.alertInfo(vm.$store.appName +" has updated. Please "+refreshAnchor+"hard refresh the app</a> or "+refreshAnchor+"click here</a>",false)
						}

					})
				}
			})
			*/

		},
		setUserAssignedServices() {
			let vm = this

			let params = {
				filters: [
					["assigned_to",this.$store.userDetails.id]
				],
				limit: 1
			}

			this.getJSON("Service/get",params).then(response => {

				if (response.success && response.data.length > 0)
					vm.$set(vm.$store.userDetails,"hasServiceJobsAssigned",true);
				else
					vm.$set(vm.$store.userDetails,"hasServiceJobsAssigned",false);
			})
		},
		storeUserPermissions(userPerms,Modules) {

			let userModulePerms = {}
			let userRole = ""

			let vm = this

			if (userPerms) {
				userRole = userPerms.role_type

				if (Modules) {

					if (userPerms.role_type == "Admin") {
						//create read/write perms for all modules

						Modules.forEach(function(mod,index){
							userModulePerms[mod] = {
								read: true,
								write: true
							}
						})
					}
					else if (userPerms.role_type == "Basic") {

						let givenModPerms = {}

						try {
							givenModPerms = JSON.parse(userPerms.module_permissions)
						}
						catch (ex) {}

						Modules.forEach(function(mod,index){
							//check this module exists in givenPerms
							if (mod in givenModPerms) {
								//check existence of read/write properties in given object, if not given, assign false

								userModulePerms[mod] = {}

								userModulePerms[mod].read = "read" in givenModPerms[mod] ? givenModPerms[mod].read : false
								userModulePerms[mod].write = "write" in givenModPerms[mod] ? givenModPerms[mod].write : false
							}
							else
								userModulePerms[mod] = {
									read: false,
									write: false
								}

						})

					}
					else {
						Modules.forEach(function(mod,index){
							userModulePerms[mod] = {
								read: false,
								write: false
							}
						})
					}
					
					vm.$store.userRole = userRole
					vm.$store.userModulePerms = userModulePerms
					vm.$store.modules = Modules
				}
			}

		},
		fetchCurrentSubscription() {
			let vm = this

			this.getJSON("Subscription/get",{},true).then(response => {
				if (response.success && response.data.length > 0) {
					vm.$store.subscription = response.data[0]

					if ("expiry" in vm.$store.subscription && vm.$store.subscription.type == 'Trial' && vm.$store.company.is_free_user == 0) {
						//calc expiry
						let hoursLeft = vm.moment(vm.$store.subscription.expiry).diff(vm.moment(),"hours")

						let text = ""
						if (hoursLeft <= 0) 
							vm.subscribeModalVisible = true
						
					}
				}
				
			})
		},
		fetchClockStatus() {
			let vm = this

			let filters = [
				['user_id',this.$store.userDetails.id]
			];

			let include = [
				{
					model: "Job",
					fields: ["job_num","job_name","address","city","province","country","postal_code","lat","long"],
					include:[{
						model: "User",
						fields:["id","slug","first_name","last_name"]
					}]
				},
				{
					model: "Service",
					fields:["job_num","job_name","address","city","province","country","postal_code","lat","long"],
					include:[{
						model: "User",
						fields:["id","slug","first_name","last_name"]
					}]
				}

			]

			let params = {
				filters: filters,
				include: include,
			}

			this.getJSON("OpenTimeLog/get",params).then(response => {
				if (response.success) {

					if (response.data.length > 0) {

						if (response.data[0].clocked_in_offsite == 1 && response.data[0].time_on_site == '0000-00-00 00:00:00')
							vm.$store.clockedIn = "offsite"
						else	
							vm.$store.clockedIn = "onsite"

						vm.$store.clockinTime = response.data[0].time_in

						let type, job_id
						if (response.data[0].job_id == 0 && response.data[0].service_id > 0) {
							type = "Service"
							job_id = response.data[0].service_id
						}
						else {
							type = "Job"
							job_id = response.data[0].job_id
						}

						vm.$store.clockedInJob = {
							type,
							id: job_id,
							job_num: response.data[0][type].job_num,
							job_name: response.data[0][type].job_name,
							slug: response.data[0][type].slug,
							details: response.data[0][type]
						}

					}
					else {
						vm.$store.clockedIn = false
						vm.$store.clockedInJob = false
					}
				}
			})
		},
		fetchLatestReleaseNote() {
			let vm = this

			let params = {
				limit: 1
			}

			this.getJSON("ReleaseNote/get",params).then(response => {
				if (response.success && response.data.length > 0)
					vm.$store.lastReleaseNoteDate = response.data[0].release_date
			})
		},
		setUserDetails() {
			if ("userDetails" in localStorage) {

				try {
					this.$store.userDetails = JSON.parse(localStorage.userDetails)
				}
				catch(e){}

				this.$store.userSlug = this.$store.userDetails.slug

				if (this.$store.userDetails.UserPermission && this.$store.userDetails.UserPermission.length > 0)
					this.$store.userRole = this.$store.userDetails.UserPermission[0].role_type

				try {
					if (this.$store.userDetails.UserPermission[0].module_permissions != "")
						this.$store.userModulePerms = JSON.parse(JSON.parse(localStorage.userDetails).UserPermission[0].module_permissions)
					else
						this.$store.userModulePerms = {}
				}
				catch(e){}

				//check TOS acknowlesdgement
				if (!this.$store.userDetails.tosUpToDate) 
					this.tosModal.visible = true
			}
		},
		startMessagePolling() {
			let vm = this

			//set up message polling
			clearInterval(vm.$store.messagePollingTimer) //make sure its not running

			//set it up
			vm.$store.messagePollingTimer = setInterval(() => {
				if (vm.loggedIn && document.visibilityState == 'visible')
					vm.checkNewMessages()
				
			},vm.$store.currentMessagePollingInterval)
		},
		startSessionTimer() {
			let vm = this

			//set up timer to log user out
			vm.$store.sessionTimer = setTimeout(() => {
				//log user out if timer is allowed to fire
				vm.logout()
				clearTimeout(vm.$store.sessionTimer)

			},5*60*1000) //5 minutes
		},
		resetSessionTimer() {
			clearTimeout(this.$store.sessionTimer)

			if (!("staySignedIn" in localStorage) || localStorage.staySignedIn == 'false')
				this.startSessionTimer()
		},
		startNotificationPolling() {
			let vm = this

			clearInterval(vm.$store.notificationPollingTimer)

			vm.$store.notificationPollingTimer = setInterval(() => {
				if (vm.loggedIn)
					vm.fetchNotifications(false,this.$store.maxRecentNotifications)
				
			},30*60*1000) //30 minutes
		},
		setMenuState() {
			if (window.innerWidth < this.menuCollapseWidth) {
				this.menuVisible = false
				this.$store.mainAreaOffset = 0
			}
			else {
				this.menuVisible = true
				this.$store.mainAreaOffset = "250px"
			}
		},
		checkCompanyInvites() {
			let vm = this

			this.getJSON("UserPermission/get",{filters:[["user_id",this.$store.userDetails.id]]}).then(response => {
				if (response.success && response.data.length > 0) {
					let perm = response.data[0]

					if ((!perm.invite_accepted || perm.invite_accepted == '0000-00-00 00:00:00') && perm.invite_declined == 0) {
						//pending invite

						vm.getJSON("Company/find/"+perm.tenant_id,{include:["ProfileImage"]}).then(response => {

							if (response.success) {

								vm.companyInviteModal.visible = true
								vm.companyInviteModal.companyName = response.data.company_name
								vm.companyInviteModal.companyImg = window.apiRoot+"/resources/profile-images/"+response.data.ProfileImage.slug+"/"+response.data.ProfileImage.filename
								vm.companyInviteModal.working = false
							}
						})
					}
				}
			})
		},
/* LISTENER HANDLERS ------------------ */
		onNewThread(jobType, jobId,externalUsers, userIds) {
			let vm = this

			this.newMessageThread.isSupportThread = false

			if (jobType && jobId > 0) {
				this.newMessageThread.jobType = jobType
				this.newMessageThread.jobId = jobId
			}
			else {
				this.newMessageThread.jobType = false
				this.newMessageThread.jobId = 0
			}

			if (userIds)
				this.newMessageThread.recipientIds = userIds

			if (externalUsers)
				this.newMessageThread.externalUsers = externalUsers

			vm.newMessageThread.visible = true
			
		},
		onNewSupportThread() {
			let vm = this

			this.newMessageThread.isSupportThread = true
			this.newMessageThread.jobId = null
			this.newMessageThread.jobType = null
			this.newMessageThread.recipientIds = []
			this.newMessageThread.externalUsers = []

			vm.newMessageThread.rendered = true

			setTimeout(() => {
				vm.newMessageThread.visible = true
			},10)
			
		},
		onNewThreadCreated() {
			this.newMessageThread.visible = false
		},
		onSpinner(visibility,msg) {
			this.spinnerVisible = visibility
			this.spinnerMsg = msg
		},
		onLoginStatus(loggedIn) {
			this.loggedIn = loggedIn
			if (loggedIn) {
				this.fetchClockStatus()
				this.setUserAssignedServices()
				this.fetchCompanyData(false,["CompanySetting","AddonApp"])
				this.setUserDetails()
				this.fetchReviewableLogs()
				this.fetchNotifications(false,this.$store.maxRecentNotifications)

				if (!this.oneSignalInitialized)
					this.initOneSignal()

				this.showNotificationPrompt()

				this.startMessagePolling()
				this.startNotificationPolling()

				//check localStorage for stay signed in directive
				if (!("staySignedIn"  in localStorage) || localStorage.staySignedIn == false || localStorage.staySignedIn == "false") {
					this.startSessionTimer()
				}
					
				else 
					clearTimeout(this.$store.sessionTimer)

				if (this.$store.userDetails.first_name == "" || this.$store.userDetails.last_name == "" || this.$store.accountSetupMode) {
					this.$store.accountSetupMode = true
					//this.alertFail("Don't forget to fill out your personal details!")
					this.$router.push("/employee/"+this.$store.userDetails.slug+"/profile")
				}
				if (this.$store.companySetupMode)
					this.$router.push("/setup")
			}
		},
		onPushAlert(alert_params) {
			alert_params.visible = true

			if ("clearPrevious" in alert_params && alert_params.clearPrevious)
				this.alerts = []

			//check for duplicate message before pushing to array
			if (!this.alerts.find(alert => alert.message == alert_params.message))
				this.alerts.unshift(alert_params) //push to front of array
		},
		onClockStatusChanged(status) {
			this.$store.clockedIn = status

			if (!status)
				this.$store.clockedInJob = false
		},
		onUpdateUserPermissions(data) {
			localStorage.userDetails = JSON.stringify(data)
			localStorage.apiKey = data.api_key
			localStorage.sessionToken = JSON.stringify(data.session_token)

			this.$store.userSlug = data.slug
			this.$store.userDetails = data
			this.$store.sessionToken = data.session_token.token
			this.$store.sessionTokenExpiry = data.session_token.expiry

			if (data.UserPermission.length > 0)
				this.storeUserPermissions(data.UserPermission[0],data.Modules)
		},
/* HOOKS */
		routerBeforeEach(to,from,next) {
			if (from.params.tab == "profile" && this.$store.accountSetupMode && (this.$store.userDetails.first_name == "" || this.$store.userDetails.last_name == ""))
				this.alertFail("Don't forget to fill out your personal details!")
			else
				next()

		},
		routerAfterEach(to,from) {
			//check if window is small, if so, retract the menu on nav
			if (window.innerWidth < this.menuCollapseWidth) {
				this.menuVisible = false
				this.menuIconsOnly = true
			}

			this.menuIconsOnly = true

			//reset userActive timer
			this.resetSessionTimer()

			this.mainMarginTop = this.calcMainMarginTop()

			/**
			* UGH. No working event after OneSignal registration to then trigger TradeTrak's
			* own registration of the OneSignal userId to our db. So ever route change we'll
			* attempt a registration
			*/
			if (this.loggedIn) {
				this.showNotificationPrompt()
				this.registerOneSignalId()

			}

		},
		clearAlerts() {
			this.alerts = []
		},
		closeAlert(timestamp) {
			let vm = this

			this.alerts.forEach(function(alert, index){
				if (alert.timestamp == timestamp)
					vm.alerts.splice(index,1)
			})
		},
	},
	created() {

	}
}